import type { OrderActivity } from "@/types";

interface OrderActivityLogProps {
  activity: OrderActivity[];
}

interface ActivityMeta {
  icon: string;
  wrap: string;
  dot: string;
}

const getActivityMeta = (label: string): ActivityMeta => {
  if (label.includes("دون استلام")) {
    return {
      icon: "ri-close-circle-line",
      wrap: "bg-red-100 text-red-500",
      dot: "bg-red-500",
    };
  }
  if (label.includes("خرج للتوصيل")) {
    return {
      icon: "ri-e-bike-2-line",
      wrap: "bg-accent-100 text-accent-800",
      dot: "bg-accent-500",
    };
  }
  if (label.includes("تسليم")) {
    return {
      icon: "ri-checkbox-circle-line",
      wrap: "bg-primary-100 text-primary-700",
      dot: "bg-primary-500",
    };
  }
  if (label.includes("استلام الطلب من العميل")) {
    return {
      icon: "ri-checkbox-circle-line",
      wrap: "bg-primary-100 text-primary-700",
      dot: "bg-primary-500",
    };
  }
  if (label.includes("جاهز للتوصيل")) {
    return {
      icon: "ri-e-bike-2-line",
      wrap: "bg-secondary-200 text-secondary-800",
      dot: "bg-secondary-600",
    };
  }
  if (label.includes("جاهز")) {
    return {
      icon: "ri-shopping-bag-3-line",
      wrap: "bg-secondary-200 text-secondary-800",
      dot: "bg-secondary-600",
    };
  }
  if (label.includes("قارب")) {
    return {
      icon: "ri-timer-line",
      wrap: "bg-accent-100 text-accent-800",
      dot: "bg-accent-500",
    };
  }
  if (label.includes("بدء تحضير")) {
    return {
      icon: "ri-fire-line",
      wrap: "bg-accent-100 text-accent-800",
      dot: "bg-accent-500",
    };
  }
  return {
    icon: "ri-file-list-3-line",
    wrap: "bg-primary-100 text-primary-700",
    dot: "bg-primary-500",
  };
};

export default function OrderActivityLog({ activity }: OrderActivityLogProps) {
  if (activity.length === 0) {
    return (
      <p className="text-sm text-foreground-500">
        لا يوجد نشاط مسجّل على هذا الطلب بعد.
      </p>
    );
  }

  const items = [...activity].reverse();

  return (
    <ol className="relative space-y-5">
      <span
        className="absolute top-2 bottom-2 right-[19px] w-px bg-background-200"
        aria-hidden="true"
      ></span>
      {items.map((entry, index) => {
        const meta = getActivityMeta(entry.label);
        const isLatest = index === 0;
        return (
          <li key={`${entry.label}-${entry.time}-${index}`} className="relative flex gap-4">
            <span
              className={`relative z-10 w-10 h-10 shrink-0 flex items-center justify-center rounded-full ${meta.wrap} ${
                isLatest ? "ring-4 ring-white" : ""
              }`}
            >
              <i className={`${meta.icon} text-lg`}></i>
            </span>
            <div className="flex-1 min-w-0 pt-1">
              <div className="flex flex-wrap items-center gap-2">
                <p className="text-sm font-semibold text-foreground-900">
                  {entry.label}
                </p>
                {isLatest && (
                  <span className="rounded-full bg-primary-50 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
                    الأحدث
                  </span>
                )}
              </div>
              <p className="mt-0.5 text-xs text-foreground-400">{entry.time}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}